var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('LoadingContainer'):_c('div',[_c('FormPanel',{attrs:{"initial":_vm.contentFileCategory.attributes,"headline":"Edit File Category","errors":_vm.errors},on:{"submit":_vm.submit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }